module.exports = __webpack_public_path__ + "img/wfy_logo@2x.492a67da.png";